// extracted by mini-css-extract-plugin
export var narrowRichtext = "richText-module--narrowRichtext--bRbea";
export var sbShowMain = "richText-module--sb-show-main--2jeHv";
export var section = "richText-module--section--yAt7L";
export var textStyle = "richText-module--textStyle--TRiYV";